// libs
import get from "lodash/get";

// constants
import { DEFAULT_VALUE } from "./constants";

export const getMapToState = (config: string) => {
    try {
        const data = JSON.parse(config);
        return {
            enabled: get(data, "enabled", DEFAULT_VALUE.enabled),
            queryString: get(data, "queryString", DEFAULT_VALUE.queryString),
            optimizeID: get(data, "optimizeID", DEFAULT_VALUE.optimizeID),
            allTraffic: get(data, "allTraffic", DEFAULT_VALUE.allTraffic),
        };
    } catch (e) {
        return DEFAULT_VALUE;
    }
};
